import { Component, Input, Output, TemplateRef, ViewChild, EventEmitter, ChangeDetectorRef, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ICountry } from "../../interfaces/icountry";
import { FormControl, FormGroup } from "@angular/forms";
import { IMultiCountry } from "../../interfaces/imulticountry";
import { CountryComparisonService } from "../../services/countrycomparison.service";
import { DownloadFileComponent } from "../downloadfile/downloadfile.component";

@Component({
    selector: "multiple-country-comparision-modal",
    templateUrl: "./multipleCountryComparisionPDFModal.component.html",
    standalone: false
})



export class MultipleCountryComparisionPDFModalComponent implements OnChanges, OnDestroy {
    private destroy$ = new Subject<void>();

    constructor(private modalService: BsModalService, private cd: ChangeDetectorRef, private countryComparisonService: CountryComparisonService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.regionCountry.forEach(element => {
            element.countries.forEach(country => {
                this.allCountries.push(country);
            });
        });
        this.allCountries = this.allCountries.sort((a, b) => a.shortName.localeCompare(b.shortName));
        this.cData = this.allCountries;
    }



    @ViewChild("multiCountryTemplate") multiCountryTemplateModal!: TemplateRef<any>;
    @Input('multiCountryData') regionCountry!: IMultiCountry[];
    @Output() formSubmit = new EventEmitter<string>();
    cData: ICountry[] = [];
    modalInstance!: BsModalRef;
    visible: boolean = false;
    downlaodMultiCountry!: FormGroup;
    selectedCountry: number = 0;
    submitted: boolean = false;
    downloadingContent: boolean = false;
    private countryIds!: string[];
    visibleRegion: string | null = null; // Track the currently visible region
    allCountries: ICountry[] = [];
    selectAll: boolean = false;

    @ViewChild("downloadmulticontries") fileDownload!: DownloadFileComponent;
    ngOnInit(): void {
        this.selectAll = false;
        this.createForm();
        this.cd.detectChanges();
    }



    createForm() {
        this.downlaodMultiCountry = new FormGroup({
            userCountries: new FormGroup({})
        });
    }

    Open(): void {
        this.selectAll = false;
        const userCountriesGroup: FormGroup = this.downlaodMultiCountry.controls["userCountries"] as FormGroup;
        this.cData.forEach(element => {
            userCountriesGroup.addControl(element.id.toString(), new FormControl(false));
        });

        this.modalInstance = this.modalService.show(this.multiCountryTemplateModal, { "class": "modal-lg" });
    }

    closePopup(): void {
        this.selectedCountry = 0;
        this.visible = false;
        this.submitted = false;
        this.selectAll = false;
        this.downlaodMultiCountry.reset();
        this.downlaodMultiCountry.markAsPristine();
        this.downlaodMultiCountry.markAsUntouched();
        this.modalInstance.hide();
        this.cData = this.allCountries // Sort the countries by name
    }

    toggle(region: string): void {
        this.visibleRegion = this.visibleRegion === region ? null : region; // Toggle the region visibility
    }

    downloadMultiCountryPDF(data: any) {
        this.downloadingContent = true;
        this.submitted = true;
        const userCountriesGroup: FormGroup = this.downlaodMultiCountry.controls["userCountries"] as FormGroup;
        this.selectedCountry = Object.keys(userCountriesGroup.controls).map(key => userCountriesGroup.controls[key]).filter(control => control.value === true).length
        if (this.selectedCountry > 1) {
            let countryIds = this.getSelectedCountries(data.userCountries)
            //TODO: CODE FOR NEXT API
            this.countryComparisonService.downloadMultiCountryComparison(countryIds)
                .pipe(takeUntil(this.destroy$))
                .subscribe((res: any) => {
                    var date: Date = new Date(Date.now());
                    var dateString: string = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
                    var comparisons: string = "MultiCountryComparison_" + dateString;
                    //var comparisons: string = this.countryIds[1] !== "" ? this.countryIds[1] : "";
                    //comparisons += this.countryIds[2] !== "" ? "_" + this.countryIds[2] : "";
                    //this.fileDownload.downloadFile(`${this.countryIds[0]}_${comparisons}_comparison_${dateString}`, res, "pdf", "application/octet-stream");
                    this.fileDownload.downloadFile(comparisons, res, "pdf", "application/octet-stream");
                    this.downloadingContent = false;
                    this.closePopup();
                }, error => {
                    this.downloadingContent = false;                    
                });
        }
    }

    private getSelectedCountries(userCountries: any): string[] {
        let selectedCountries: string[] = [];
        let checkBoxes: string[] = Object.keys(userCountries);
        for (const key of checkBoxes) {
            if (userCountries[key] === true) {
                const found: ICountry | undefined = this.cData.find(c => c.id.toString() === key);
                if (found != undefined) {
                    selectedCountries.push(found.code);
                }
            }
        }
        return selectedCountries;
    }

    selectAllCountries(event: any) {
        this.selectAll = event.target.checked;
        let userCountriesGroup: FormGroup = this.downlaodMultiCountry.controls["userCountries"] as FormGroup;
        let countryKeys = this.cData.map(x => x.id.toString());
        Object.keys(userCountriesGroup.controls).forEach(key => {
            userCountriesGroup.controls[key].setValue(this.selectAll);
        });
        if (this.cData.length == Object.keys(userCountriesGroup.controls).map(key => userCountriesGroup.controls[key]).filter(control => control.value === true).length) {
            this.selectAll = true;
        }
        else {
            this.selectAll = false;
        }
        this.selectedCountry = Object.keys(userCountriesGroup.controls).map(key => userCountriesGroup.controls[key]).filter(control => control.value === true).length;
    }

    getUserCountriesFormGroup(): FormGroup {
        return this.downlaodMultiCountry.controls["userCountries"] as FormGroup;
    }

    onCheckboxChange(event: any) {
        let userCountriesGroup: FormGroup = this.downlaodMultiCountry.controls["userCountries"] as FormGroup;
        userCountriesGroup.controls[event.target.value].setValue(event.target.checked)

        if (this.cData.length == Object.keys(userCountriesGroup.controls).map(key => userCountriesGroup.controls[key]).filter(control => control.value === true).length) {
            this.selectAll = true;
        }
        else {
            this.selectAll = false;
        }
        this.selectedCountry = Object.keys(userCountriesGroup.controls).map(key => userCountriesGroup.controls[key]).filter(control => control.value === true).length;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}